import FeatureLayer = require("esri/layers/FeatureLayer");
import GraphicsLayer = require("esri/layers/GraphicsLayer");
import SelectionResultsTable from "./SelectionResultTable";
import ToolButton from "./toolButton";

// clearGraphicsTool

export default class ClearGraphicsTool extends ToolButton {
  deactivateTool() {
    // console.log("clearGraphicsTool deactivateTool")
  }

  activateTool(event: any) {
    // console.log("panTool start", this.view)
    try {
      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        const drawLayer: GraphicsLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;
        if (drawLayer) {
          drawLayer.removeAll();
        }

        const pinLayer: FeatureLayer = this.view.map.findLayerById("pinLayer") as FeatureLayer;
        if (pinLayer) {
          pinLayer
            .queryFeatures()
            .then(results => {
              pinLayer.applyEdits({ deleteFeatures: results.features }).catch(error => {
                console.error("Error: clearGraphicsTool: Removing Push Pins: " + error.message);
              });
            })
            .catch(error => {
              console.error("Error: clearGraphicsTool: Getting Current Push Pins: " + error.message);
            });
        }

        const pinLabelText: HTMLInputElement = document.getElementById("pinLabelText") as HTMLInputElement;
        if (pinLabelText) {
          pinLabelText.value = "";
        }

        this.view.graphics.removeAll();
        this.view.popup.close();
        const selectionResultsTable = new SelectionResultsTable(this);
        selectionResultsTable.hideResultsTable();
      }
      this.toolbar.setPanAsActiveTool();
    } catch (error) {
      console.error("Error: in clearGraphicsTool " + +error.message);
    }
  }
}
